import { IContractBook, SupportedChainId } from "@eulerxyz/core-sdk"
import { ContractFunctionConfig } from "@eulerxyz/evc-sdk"
import { BaseTransactionFactory } from "./BaseTransactionFactory"
import {
  FeeFlowTransactionItem,
  TransactionItemUnion,
  TransactionItems,
  isFeeFlowTransactionItem,
} from "./types"

export class FeeFlowTransactionFactory extends BaseTransactionFactory {
  customData: {
    [key: string]: any
  }

  constructor(chainId: SupportedChainId, contractBook: IContractBook) {
    super(chainId, contractBook)
    this.customData = {}
  }

  typeGuardConvertMultiple(
    _transactions: TransactionItems, // todo: modify this to use more specific type
  ): ContractFunctionConfig[] {
    const contractCallReadyTxs: ContractFunctionConfig[] = []
    for (const tx of _transactions) {
      const call = this.typeGuardConvertSingle(tx)
      contractCallReadyTxs.push(call)
    }
    return contractCallReadyTxs
  }

  typeGuardConvertSingle(
    _transaction: TransactionItemUnion, // todo: modify this to use more specific type
  ): ContractFunctionConfig {
    if (isFeeFlowTransactionItem(_transaction)) {
      return this.feeflowBuy(_transaction)
    }

    throw this.errorUnsupportedTransactionType(_transaction)
  }

  feeflowBuy(
    _transaction: FeeFlowTransactionItem,
  ): ContractFunctionConfig<typeof this.contractBook.feeFlow.abi, "buy"> {
    return {
      address: this.contractBook.feeFlow.address[this.chainId],
      abi: this.contractBook.feeFlow.abi,
      functionName: "buy",
      onBehalfOfAccount: _transaction.from,
      value: 0n,
      args: [
        _transaction.vaults,
        _transaction.recipient,
        _transaction.epochPeriod,
        _transaction.deadline,
        _transaction.maxPrice,
      ],
    }
  }

  // after implementing the above methods
  // remember to add this to GeneralTransactionFactory
  // this is the entry point for transaction transformation
}
